
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[...alias]",
      function () {
        return require("private-next-pages/catalog/[...alias].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/[...alias]"])
      });
    }
  